import { render, staticRenderFns } from "./WebPartCallToActionDesigner.vue?vue&type=template&id=5ecb81f2&"
import script from "./WebPartCallToActionDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartCallToActionDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports